var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.25 0h13.5a.75.75 0 1 1 0 1.5H1.25a.75.75 0 1 1 0-1.5zm0 5h13.5a.75.75 0 1 1 0 1.5H1.25a.75.75 0 1 1 0-1.5zm0 5h13.5a.75.75 0 1 1 0 1.5H1.25a.75.75 0 1 1 0-1.5z","fill":"#424242","fillRule":"evenodd"}));
}

Hamburger.defaultProps = {"width":"16","height":"12","viewBox":"0 0 16 12"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
